import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { deleteKeyPersonAction } from "../action/deleteKeyPersonAction";

const initialState: CreateAppData = {
  data: null,
  loading: false,
  error: null,
};

const deleteKeyPersonSlice = createSlice({
  name: "deleteKeyPersonSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteKeyPersonAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteKeyPersonAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteKeyPersonAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const deleteKeyPersonReducer = deleteKeyPersonSlice.reducer;
